import type {
  CompetitorProduct,
  CompetitorProductCreateInput,
  CompetitorProductUpdateInput,
} from "@/graphql/codegen/graphql"
import type { CompetitorProductFormValues } from "@/screens/ManageProducts/components/CompetitorProducts/forms/competitorProductSchema"

/**
 * Converts API CompetitorProduct entity to form data for edit mode
 */
export const buildDefaultFormValues = (data: CompetitorProduct): CompetitorProductFormValues => {
  return {
    competitorProductId: data.competitorProductId,
    productName: data.productName,
    chemicalName: data.chemicalName || "",
    casNumbers: data.casNumbers || [],
    manufacturer: data.manufacturer || "",
    distributors: data.distributors?.map((d) => d.companyId) || [],
    technicalFile: undefined, // File uploads are handled separately
  }
}

/**
 * Transforms form data to API create input format
 * Filters empty values and converts to proper API types
 * Note: Empty strings are preserved to allow clearing fields
 */
export const serializeCreateInput = (input: CompetitorProductFormValues): CompetitorProductCreateInput => {
  return {
    productName: input.productName,
    chemicalName: input.chemicalName,
    casNumbers: input.casNumbers?.filter((cas): cas is string => cas !== undefined && cas.trim() !== "") || undefined,
    manufacturer: input.manufacturer,
    distributorIds: input.distributors,
  }
}

/**
 * Transforms form data to API update input format
 * Similar to create but includes competitorProductId
 * Note: Empty strings are preserved to allow clearing fields on backend
 */
export const serializeUpdateInput = (
  input: CompetitorProductFormValues,
  competitorProductId: string
): CompetitorProductUpdateInput => {
  return {
    competitorProductId,
    productName: input.productName,
    chemicalName: input.chemicalName,
    casNumbers: input.casNumbers?.filter((cas): cas is string => cas !== undefined && cas.trim() !== "") || undefined,
    manufacturer: input.manufacturer,
    distributorIds: input.distributors,
  }
}
